import { Link } from "react-router-dom";
import { MessageCircle, Phone, Mail } from "lucide-react";
import { useConfig } from "../../lib/config";
import { waLink } from "../../lib/api";

export function Footer() {
  const config = useConfig();
  const wa = waLink(config.whatsapp_number || "", "Hola, quiero consultar sobre productos AZOO.");

  return (
    <footer className="bg-white text-zinc-500 text-sm py-12 border-t border-zinc-200" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div className="space-y-4">
          <img src="/logo-azoo.png" alt="AZOO Costa Rica" className="h-9 w-auto" />
          <p className="text-xs leading-relaxed" data-testid="footer-legal">
            Distribuido por <span className="text-zinc-950 font-semibold">Tugeko S.A.</span> — Distribuidora de artículos para mascotas en Costa Rica. Ventas únicamente al por mayor.
          </p>
          <img src="/logo-tugeko.png" alt="Tugeko S.A." className="h-10 w-auto" data-testid="footer-tugeko-logo" />
        </div>
        <div className="space-y-3">
          <h3 className="text-zinc-950 font-bold text-sm uppercase tracking-wider">Contacto</h3>
          <a href={wa} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-zinc-950 transition-colors" data-testid="footer-whatsapp-link">
            <MessageCircle className="w-4 h-4 text-brand-600" /> WhatsApp {config.whatsapp_display}
          </a>
          <a href={`tel:+${config.whatsapp_number}`} className="flex items-center gap-2 hover:text-zinc-950 transition-colors" data-testid="footer-phone-link">
            <Phone className="w-4 h-4 text-brand-600" /> {config.phone_display}
          </a>
          {config.email && (
            <a href={`mailto:${config.email}`} className="flex items-center gap-2 hover:text-zinc-950 transition-colors" data-testid="footer-email-link">
              <Mail className="w-4 h-4 text-brand-600" /> {config.email}
            </a>
          )}
        </div>
        <div className="space-y-3">
          <h3 className="text-zinc-950 font-bold text-sm uppercase tracking-wider">Explorar</h3>
          <div className="flex flex-col gap-2 text-xs">
            <Link to="/#productos" className="hover:text-zinc-950 transition-colors">Productos</Link>
            <Link to="/#por-que" className="hover:text-zinc-950 transition-colors">¿Por qué AZOO?</Link>
            <Link to="/#distribuidores" className="hover:text-zinc-950 transition-colors">Distribuidores</Link>
            <Link to="/blog" className="hover:text-zinc-950 transition-colors">Consejos</Link>
            <Link to="/#preguntas" className="hover:text-zinc-950 transition-colors">Preguntas frecuentes</Link>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 pt-6 border-t border-zinc-200 text-xs text-zinc-400 flex flex-col sm:flex-row justify-between gap-2">
        <span>AZOO Costa Rica · Lo natural siempre es mejor.</span>
        <Link to="/admin" className="hover:text-zinc-950 transition-colors" data-testid="footer-admin-link">Acceso administrador</Link>
      </div>
    </footer>
  );
}
